import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import StaffAttendanceList from "./StaffAttendanceList";
import { popupNavigation } from "../../util/functions/UniversalFunctions";
import AttendanceReportDropDown from "../../components/AttendanceReportDropdown";
import { useState } from "react";
import StaffAttendanceReportDateWise from "../../components/modal/StaffAttendanceReportDateWise";

export default function StaffAttendance() {
  const navigate = useNavigate();

  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const menuItems = [
    {
      label: "Academic Year Wise",
      onClick: () => navigate(popupNavigation("downloadStaffAttendanceReport")),
    },
    {
      label: "Month Wise",
      onClick: () => navigate(popupNavigation("staffAttendance")),
    },
    {
      label: "Date Wise",
      onClick: () => setIsDateModalOpen(true),
    },
  ];

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col md:flex-row justify-between">
        <PageHeader showBack />
        <div className="flex justify-end items-end">
          <AttendanceReportDropDown menuItems={menuItems} />
        </div>
      </div>
      <StaffAttendanceList selectedDate={selectedDate} setSelectedDate={setSelectedDate} />

      {isDateModalOpen && (
        <StaffAttendanceReportDateWise
          onClose={() => setIsDateModalOpen(false)}
          onSuccess={(date: string) => {
            setSelectedDate(date);
            setIsDateModalOpen(false);
          }}
        />
      )}
    </div>
  );
}
